<template>
  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 mt-1">
    <v-select
      :ref="refName"
      :placeholder="generatedPlaceholder"
      class="style-chooser"
      :label="label"
      style="width: 100%;"
      v-model="selectValue"
      :options="options"
      :reduce="(item) => item[reduceKey]"
    />
  </div>
</template>

<script>
export default {
  name: 'FormSelect',
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    refName: {
      type: String,
      default: 'select',
    },
    label: {
      type: String,
      default: 'name',
    },
    placeholder: {
      type: String,
      default: null,
    },
    reduceKey: {
      type: String,
      default: 'id',
    },
  },
  computed: {
    selectValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    generatedPlaceholder() {
      // Use custom placeholder if provided, otherwise generate from refName
      return this.placeholder || `Pilih ${this.refName}`
    },
  },
}
</script>
